import React, { useState } from 'react';
import DharmaImpact from './DharmaImpact';
import DharmaWatchdog from './DharmaWatchdog';
import FinancialAudit from './FinancialAudit';
import VesselRegistry from './VesselRegistry';
import BatchTimeline from './BatchTimeline';
import SanctuaryQueue from './SanctuaryQueue';
import SevagramModeration from './SevagramModeration';
import NotificationsLog from './NotificationsLog';
import MasterAdminBanner from './MasterAdminBanner';
import ChainAnchorPanel from './ChainAnchorPanel';

const TABS = [
  { id: 'impact',   label: 'Dharma Impact',       Component: DharmaImpact },
  { id: 'artha',    label: 'Artha Integrity',     Component: FinancialAudit },
  { id: 'dharma',   label: 'Proof-of-Seva',       Component: DharmaWatchdog },
  { id: 'vessels',  label: 'Vessel Registry',     Component: VesselRegistry },
  { id: 'batches',  label: 'Batch Timeline',      Component: BatchTimeline },
  { id: 'queue',    label: 'Sanctuary Onboarding',Component: SanctuaryQueue },
  { id: 'mod',      label: 'Sevagram Filter',     Component: SevagramModeration },
  { id: 'mail',     label: 'Correspondence',      Component: NotificationsLog },
  { id: 'chain',    label: 'On-chain Anchor',     Component: ChainAnchorPanel },
];

const AdminShell = () => {
  const [active, setActive] = useState(TABS[0].id);
  const ActiveComponent = TABS.find((t) => t.id === active)?.Component || TABS[0].Component;

  return (
    <div data-testid="admin-shell" className="space-y-10">
      <MasterAdminBanner />
      <nav
        data-testid="admin-tabs"
        className="flex flex-wrap gap-2 border-b border-[#C1D7E2] pb-4"
      >
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setActive(t.id)}
            data-testid={`admin-tab-${t.id}`}
            className={`px-4 py-2 text-[11px] tracking-[0.22em] uppercase font-medium border transition-colors ${
              active === t.id
                ? 'border-[#7C9CB1] bg-[#7C9CB1] text-[#F4F8F9]'
                : 'border-[#C1D7E2] text-[#7C9CB1] hover:bg-[#C1D7E2]/40'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <ActiveComponent />
    </div>
  );
};

export default AdminShell;
